export default __webpack_public_path__ + "static/media/songsyou.4b311690.png";